import { ChevronDown } from '@sortlist-frontend/design-system/icons';

import type { RankingFullRankingEntry, RankingFullRankingFilters } from '../../types';
import { FilterableFullRanking } from './FilterableFullRanking';
import { FullRankingTable } from './FullRankingTable';

interface FullRankingDisclosureProps {
  caption: string;
  entries: readonly RankingFullRankingEntry[];
  filters?: RankingFullRankingFilters;
  summaryLabel?: string;
  locale: string;
}

export const FullRankingDisclosure = (props: FullRankingDisclosureProps) => {
  const { caption, entries, filters, summaryLabel, locale } = props;

  if (filters != null) {
    return <FilterableFullRanking caption={caption} entries={entries} filters={filters} locale={locale} />;
  }
  if (summaryLabel == null) {
    return <FullRankingTable caption={caption} entries={entries} locale={locale} />;
  }

  return (
    <details open className="group">
      <summary className="inline-flex cursor-pointer list-none items-center gap-2 rounded-full border border-secondary-200 bg-white px-4 py-2 text-sm font-semibold text-secondary-950 [&::-webkit-details-marker]:hidden">
        <ChevronDown size={16} className="transition-transform group-open:rotate-180" aria-hidden="true" />
        {summaryLabel}
      </summary>
      <div className="mt-4">
        <FullRankingTable caption={caption} entries={entries} locale={locale} />
      </div>
    </details>
  );
};
